import { Navigate, useLocation } from 'react-router-dom';
import { crmAuth } from '@/services/auth/crm-auth';

interface CRMAuthGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export function CRMAuthGuard({
  children,
  requireAuth = true,
}: CRMAuthGuardProps) {
  const location = useLocation();

  // Check if CRM client is authenticated (has token in localStorage)
  const isAuthenticated = crmAuth.isAuthenticated();
  const client = crmAuth.getClient();

  // If auth required but not authenticated, redirect to /crm (login page)
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/crm" state={{ from: location }} replace />;
  }

  // If on login page (/crm) and already authenticated, redirect to dashboard
  if (!requireAuth && isAuthenticated && client) {
    // Check if they need to change password first
    if (crmAuth.requiresPasswordChange()) {
      // Allow access to login page for password change flow
      return <>{children}</>;
    }
    return <Navigate to="/crm/dashboard" replace />;
  }

  return <>{children}</>;
}
